import { useParams, Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { BookReportList } from 'app/bookreport/BookReportList';
import { ReadingPictureList } from 'app/readingPicture/ReadingPictureList';
import { VideoList } from 'app/videoreport/VideoList';
import { AuthorMeetingListByUser } from '../authorMeeting/AuthorMeetingListByUser';
import { StoryListByUser } from '../donghwa/story/StoryListByUser';
import { UserLnbItem } from "./UserLnbItem";


export const ActivityPage = ({ user }) => {
    const { school, "*": activityCode } = useParams();
    const auth = useSelector(state => state.auth);
    const config = useSelector(state => state.config);

    return (
        <div className="myActivityPage">
            <ul className="activity_lnb">
                <UserLnbItem lnbCode={activityCode} path={`/${user}/activity/bookreport`} >독서감상문</UserLnbItem>
                <UserLnbItem lnbCode={activityCode} path={`/${user}/activity/picture`} >독서화</UserLnbItem>
                <UserLnbItem lnbCode={activityCode} path={`/${user}/activity/photo`} >독서사진</UserLnbItem>
                <UserLnbItem lnbCode={activityCode} path={`/${user}/activity/video`} >독서영상</UserLnbItem>
                <UserLnbItem lnbCode={activityCode} path={`/${user}/activity/meeting`} use={user === auth.id} >책이랑 나랑</UserLnbItem>
                <UserLnbItem lnbCode={activityCode} path={`/${user}/activity/dongwha`} use={user === auth.id && config.useDongwha} >동화서당</UserLnbItem>
            </ul>
            <div>
                <Routes>
                    {user === auth.id &&
                        <>
                            <Route path="/meeting" element={<AuthorMeetingListByUser />} />
                            <Route path="/dongwha" element={<StoryListByUser />} />
                        </>
                    }
                    <Route path="/bookreport" element={<BookReportList path={`/${school}/user/${user}/activity/bookreport`} forcedData={{ user }} />} />
                    <Route path="/picture" element={<ReadingPictureList path={`/${school}/user/${user}/activity/picture`} forcedData={{ user, type: 'picture' }} />} />
                    <Route path="/photo" element={<ReadingPictureList path={`/${school}/user/${user}/activity/photo`} forcedData={{ user, type: 'photo' }} />} />
                    <Route path="/video" element={<VideoList path={`/${school}/user/${user}/activity/video`} forcedData={{ user }} />} />
                </Routes>
            </div>
        </div>
    )
}